import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const applinksAdministrationEditRoute: InvariantJiraRoute = {
	name: 'global-settings-products-applinks-administration-edit',
	path: '/jira/settings/applinks/:applinkId/edit',
	exact: true,
};
